export default "__VITE_ASSET__DUym6ZEU__"